import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import CloseFiltersIcon from './close_filters.svg'
import FiltersCheckIcon from './filters_check.svg'
import { Checkbox } from 'src/components/Checkbox'
import { SelectFilters } from 'src/components/SelectFilters'
import bem from './bem'
import styles from './mobileFilters.module.scss'

const cName = bem.with('MobileFilters')

export class MobileFilters extends Component {
  state = {
    isServer: true,
  }

  componentDidMount() {
    this.setState(
      {
        isServer: false,
      },
      () => {
        document.body.append(this.el)
      }
    )
  }

  componentWillUnmount() {
    document.body.removeChild(this.el)
  }

  renderFilters = () => {
    const {
      isMobileFiltersPanelOpened,
      closeMobileFilters,
      filters,
      onlyVerifiedIsAvailable,
      onlyVerified,
      changeOnlyVerified,
    } = this.props

    return (
      <div className={styles.root}>
        <div className={cName({ active: isMobileFiltersPanelOpened })}>
          <div className={cName('Header')}>
            <span>Filters</span>
            <div
              className={cName('CloserContainer')}
              onClick={closeMobileFilters}
            >
              <CloseFiltersIcon />
            </div>
          </div>
          <div className={cName('FiltersPanel')}>
            {onlyVerifiedIsAvailable && (
              <Checkbox
                className='MarketsFilter'
                checked={onlyVerified}
                label='Only verified'
                onChange={changeOnlyVerified}
              />
            )}

            {filters.map(filter => {
              if (filter.name === 'pair') {
                return (
                  <Fragment key={filter.name}>
                    <div className={cName('FilterLabel')}>
                      {filter.labelInside}:
                    </div>
                    <SelectFilters
                      withInternalScroll
                      key={filter.name}
                      selectList={filter.options}
                      targetValue={filter.value}
                      onChangeAction={filter.onChangeHandler}
                      className={cName('MobileSelectFilter')}
                    />
                  </Fragment>
                )
              }

              return (
                <Fragment key={filter.name}>
                  <div className={cName('FilterLabel')}>
                    {filter.labelInside}:
                  </div>
                  {filter.options.map(option => (
                    <div
                      onClick={() => filter.onChangeHandler(option.value)}
                      key={option.value}
                      className={cName('FilterOption')}
                    >
                      {option.value === filter.value && <FiltersCheckIcon />}
                      <div
                        className={cName('FilterValue', {
                          active: option.value === filter.value,
                        })}
                      >
                        {option.value}
                      </div>
                    </div>
                  ))}
                </Fragment>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { isServer } = this.state
    if (isServer) {
      return null
    }

    if (!this.el) {
      this.el = document.createElement('div')
    }

    return ReactDOM.createPortal(this.renderFilters(), this.el)
  }
}
